<div class="media-video-embed">
    <iframe [src]="url" frameborder="0" title="" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
</div>

<!--<app-timer [session]="sectionContentSession" [type]="'content'"></app-timer>-->

<style>
    /* Contenedor responsivo 16:9 para que el video tenga el alto correcto
       (antes el iframe quedaba con height fijo y se veía muy ancho/aplastado). */
    .media-video-embed {
        position: relative;
        width: 100%;
        padding-bottom: 56.25%;
        height: 0;
        background: #000;
        border-radius: 8px;
        overflow: hidden;
    }

    .media-video-embed iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
</style>
